import { render, staticRenderFns } from "./FactoryTour.vue?vue&type=template&id=316ab5a8&scoped=true&"
import script from "./FactoryTour.vue?vue&type=script&lang=js&"
export * from "./FactoryTour.vue?vue&type=script&lang=js&"
import style0 from "./FactoryTour.vue?vue&type=style&index=0&id=316ab5a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ab5a8",
  null
  
)

export default component.exports